/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionLeadExternalEhrPatient } from './PalAuthSubmissionLeadExternalEhrPatient';
import {
    PalAuthSubmissionLeadExternalEhrPatientFromJSON,
    PalAuthSubmissionLeadExternalEhrPatientFromJSONTyped,
    PalAuthSubmissionLeadExternalEhrPatientToJSON,
} from './PalAuthSubmissionLeadExternalEhrPatient';
import type { PalAuthSubmissionLeadFacility } from './PalAuthSubmissionLeadFacility';
import {
    PalAuthSubmissionLeadFacilityFromJSON,
    PalAuthSubmissionLeadFacilityFromJSONTyped,
    PalAuthSubmissionLeadFacilityToJSON,
} from './PalAuthSubmissionLeadFacility';
import type { PalAuthSubmissionLeadScreenerLeadInfo } from './PalAuthSubmissionLeadScreenerLeadInfo';
import {
    PalAuthSubmissionLeadScreenerLeadInfoFromJSON,
    PalAuthSubmissionLeadScreenerLeadInfoFromJSONTyped,
    PalAuthSubmissionLeadScreenerLeadInfoToJSON,
} from './PalAuthSubmissionLeadScreenerLeadInfo';
import type { PalAuthSubmissionLeadStatus } from './PalAuthSubmissionLeadStatus';
import {
    PalAuthSubmissionLeadStatusFromJSON,
    PalAuthSubmissionLeadStatusFromJSONTyped,
    PalAuthSubmissionLeadStatusToJSON,
} from './PalAuthSubmissionLeadStatus';
import type { PalAuthSubmissionLeadWaitlist } from './PalAuthSubmissionLeadWaitlist';
import {
    PalAuthSubmissionLeadWaitlistFromJSON,
    PalAuthSubmissionLeadWaitlistFromJSONTyped,
    PalAuthSubmissionLeadWaitlistToJSON,
} from './PalAuthSubmissionLeadWaitlist';

/**
 * 
 * @export
 * @interface PalAuthSubmissionLead
 */
export interface PalAuthSubmissionLead {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    lead_received_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    source_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    status_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    connector?: PalAuthSubmissionLeadConnectorEnum;
    /**
     * 
     * @type {PalAuthSubmissionLeadStatus}
     * @memberof PalAuthSubmissionLead
     */
    status?: PalAuthSubmissionLeadStatus;
    /**
     * 
     * @type {PalAuthSubmissionLeadWaitlist}
     * @memberof PalAuthSubmissionLead
     */
    waitlist?: PalAuthSubmissionLeadWaitlist;
    /**
     * Legacy display name. Use `admission_status_code`.
     * @type {string}
     * @memberof PalAuthSubmissionLead
     * @deprecated
     */
    admission_status?: PalAuthSubmissionLeadAdmissionStatusEnum;
    /**
     * Canonical admission-status code; legality enforced by backend state machines.
     * @type {string}
     * @memberof PalAuthSubmissionLead
     */
    admission_status_code?: PalAuthSubmissionLeadAdmissionStatusCodeEnum;
    /**
     * 
     * @type {PalAuthSubmissionLeadScreenerLeadInfo}
     * @memberof PalAuthSubmissionLead
     */
    screener_lead_info?: PalAuthSubmissionLeadScreenerLeadInfo;
    /**
     * 
     * @type {PalAuthSubmissionLeadFacility}
     * @memberof PalAuthSubmissionLead
     */
    facility?: PalAuthSubmissionLeadFacility;
    /**
     * 
     * @type {PalAuthSubmissionLeadExternalEhrPatient}
     * @memberof PalAuthSubmissionLead
     */
    external_ehr_patient?: PalAuthSubmissionLeadExternalEhrPatient;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityOfRochesterMedicine: 'EpicCare Link University of Rochester Medicine',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    EpicCareLinkLexingtonMedicalCenter: 'EpicCare Link Lexington Medical Center',
    EpicCareLinkMedicalUniversityOfSouthCarolina: 'EpicCare Link Medical University of South Carolina',
    EpicCareLinkEssentiaHealth: 'EpicCare Link Essentia Health',
    EpicCareLinkUwHealth: 'EpicCare Link UW Health',
    EpicCareLinkNorthMississippiHealthServices: 'EpicCare Link North Mississippi Health Services',
    EpicCareLinkOregonHealthScienceUniversity: 'EpicCare Link Oregon Health & Science University',
    EpicCareLinkLcmcHealth: 'EpicCare Link LCMC Health',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next',
    Roc: 'Roc'
} as const;
export type PalAuthSubmissionLeadConnectorEnum = typeof PalAuthSubmissionLeadConnectorEnum[keyof typeof PalAuthSubmissionLeadConnectorEnum];

/**
 * @export
 */
export const PalAuthSubmissionLeadAdmissionStatusEnum = {
    Booked: 'Booked',
    MovedIn: 'Moved-In',
    MovedOut: 'Moved-Out',
    Lost: 'Lost',
    Hospitalized: 'Hospitalized',
    Loa: 'LOA',
    IntakeInProgress: 'Intake in Progress',
    Scheduled: 'Scheduled',
    Admitted: 'Admitted',
    Transferred: 'Transferred',
    Discharged: 'Discharged',
    NoAdmit: 'No Admit'
} as const;
export type PalAuthSubmissionLeadAdmissionStatusEnum = typeof PalAuthSubmissionLeadAdmissionStatusEnum[keyof typeof PalAuthSubmissionLeadAdmissionStatusEnum];

/**
 * @export
 */
export const PalAuthSubmissionLeadAdmissionStatusCodeEnum = {
    Booked: 'booked',
    MovedIn: 'moved_in',
    MovedOut: 'moved_out',
    Lost: 'lost',
    Hospitalized: 'hospitalized',
    Loa: 'loa',
    None: 'none',
    IntakeInProgress: 'intake_in_progress',
    Scheduled: 'scheduled',
    Admitted: 'admitted',
    Transferred: 'transferred',
    Discharged: 'discharged',
    NoAdmit: 'no_admit'
} as const;
export type PalAuthSubmissionLeadAdmissionStatusCodeEnum = typeof PalAuthSubmissionLeadAdmissionStatusCodeEnum[keyof typeof PalAuthSubmissionLeadAdmissionStatusCodeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLead interface.
 */
export function instanceOfPalAuthSubmissionLead(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionLeadFromJSON(json: any): PalAuthSubmissionLead {
    return PalAuthSubmissionLeadFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_received_date': !exists(json, 'lead_received_date') ? undefined : json['lead_received_date'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'source_name': !exists(json, 'source_name') ? undefined : json['source_name'],
        'status_id': !exists(json, 'status_id') ? undefined : json['status_id'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
        'status': !exists(json, 'status') ? undefined : PalAuthSubmissionLeadStatusFromJSON(json['status']),
        'waitlist': !exists(json, 'waitlist') ? undefined : PalAuthSubmissionLeadWaitlistFromJSON(json['waitlist']),
        'admission_status': !exists(json, 'admission_status') ? undefined : json['admission_status'],
        'admission_status_code': !exists(json, 'admission_status_code') ? undefined : json['admission_status_code'],
        'screener_lead_info': !exists(json, 'screener_lead_info') ? undefined : PalAuthSubmissionLeadScreenerLeadInfoFromJSON(json['screener_lead_info']),
        'facility': !exists(json, 'facility') ? undefined : PalAuthSubmissionLeadFacilityFromJSON(json['facility']),
        'external_ehr_patient': !exists(json, 'external_ehr_patient') ? undefined : PalAuthSubmissionLeadExternalEhrPatientFromJSON(json['external_ehr_patient']),
    };
}

export function PalAuthSubmissionLeadToJSON(value?: PalAuthSubmissionLead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_received_date': value.lead_received_date,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'source_name': value.source_name,
        'status_id': value.status_id,
        'connector': value.connector,
        'status': PalAuthSubmissionLeadStatusToJSON(value.status),
        'waitlist': PalAuthSubmissionLeadWaitlistToJSON(value.waitlist),
        'admission_status': value.admission_status,
        'admission_status_code': value.admission_status_code,
        'screener_lead_info': PalAuthSubmissionLeadScreenerLeadInfoToJSON(value.screener_lead_info),
        'facility': PalAuthSubmissionLeadFacilityToJSON(value.facility),
        'external_ehr_patient': PalAuthSubmissionLeadExternalEhrPatientToJSON(value.external_ehr_patient),
    };
}

